{
  "webhooks": {
    "navigation_title": "Webhooks",
    "title": "Webhooks",
    "create": "Create Webhook",
    "docs": "Documentation",
    "delete_webhook": "Delete Webhook",
    "conditions": "Conditions",
    "types": {
      "device": "Device",
      "alert": "Alert"
    },
    "dialogs": {
      "delete": {
        "title": "Are you sure",
        "content": "Are you sure you want to delete this web hook? You can't undo this action",
        "confirm": "Delete"
      }
    }
  }
}